import { getEnv } from "@/shared/utils/env-utils.ts";
import { BrowserCacheLocation, Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { KnownGroupIds } from "../services/groupService";

const baseUrl = window.location.origin;
const clientId = getEnv("VITE_AZURE_CLIENT_ID") ?? "5f13e15d-0dd7-43b4-ba73-9ca086a81ba2";
const tenantId = getEnv("VITE_AZURE_TENANT_ID") ?? "64458159-0d9a-4d84-966f-1a13c0ac7a34";
const redirectUri = getEnv("VITE_REDIRECT_URI") ?? baseUrl;
const postLogoutRedirectUri = getEnv("VITE_POST_LOGOUT_REDIRECT_URI") ?? baseUrl;

export const apiScopes = [getEnv("VITE_API_SCOPES") ?? `api://${clientId}/Default`];

/**
 * MSAL configuration using fragment-based authentication
 */
export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri,
        postLogoutRedirectUri,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
        allowRedirectInIframe: true,
        tokenRenewalOffsetSeconds: 300,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;

                switch (level) {
                    case LogLevel.Error:
                        console.error(`MSAL - ${message}`);
                        break;
                    case LogLevel.Info:
                    case LogLevel.Verbose:
                        if (getEnv("VITE_ENV") === "dev") {
                            console.info(`MSAL - ${message}`);
                        }
                        break;
                    case LogLevel.Warning:
                        console.warn(`MSAL - ${message}`);
                        break;
                }
            },
            logLevel: getEnv("VITE_ENV") === "production" ? LogLevel.Error : LogLevel.Info,
            piiLoggingEnabled: false,
        },
    },
};

/**
 * Login request configuration
 */
export const loginRequest = {
    scopes: apiScopes,
    responseMode: "fragment",
    prompt: "select_account",
    extraQueryParameters: {
        claims: JSON.stringify({
            id_token: {
                groups: {
                    essential: true,
                    values: Object.keys(KnownGroupIds),
                },
            },
        }),
    },
};

/**
 * Token request configuration for silent token acquisition
 */
export const tokenRequest = {
    scopes: apiScopes,
    redirectUri: redirectUri,
};
export const msalInstance = new PublicClientApplication(msalConfig);

void msalInstance.initialize().then(() => {
    msalInstance
        .handleRedirectPromise({ navigateToLoginRequestUrl: true })
        .then((response) => {
            if (response) {
                console.debug("Successfully processed redirect", response);
            }
        })
        .catch((error) => {
            console.error("Error processing redirect", error);
        });
});
